import React, { useState } from 'react';
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import noDataImage from '../assets/no-data.png'; // Make sure this image exists

const PledgeRecord = () => {
  const [activeTab, setActiveTab] = useState('inProgress');
  const navigate = useNavigate();

  return (
    <Container className="py-3 text-center">
      <Button variant="light" className="mb-3 text-start" onClick={() => navigate(-1)}>
        <i className="bi bi-arrow-left"></i> Pledge Record
      </Button>

      <div className="d-flex justify-content-center mb-3">
        <span
          onClick={() => setActiveTab('inProgress')}
          style={{
            fontWeight: activeTab === 'inProgress' ? 'bold' : 'normal',
            color: activeTab === 'inProgress' ? '#e57373' : '#888',
            borderBottom: activeTab === 'inProgress' ? '2px solid #e57373' : 'none',
            marginRight: '20px',
            cursor: 'pointer',
          }}
        >
          In progress
        </span>
        <span
          onClick={() => setActiveTab('closed')}
          style={{
            fontWeight: activeTab === 'closed' ? 'bold' : 'normal',
            color: activeTab === 'closed' ? '#e57373' : '#888',
            borderBottom: activeTab === 'closed' ? '2px solid #e57373' : 'none',
            cursor: 'pointer',
          }}
        >
          Closed
        </span>
      </div>

      <div className="text-center">
        <img src={noDataImage} alt="No Data" style={{ width: 100, opacity: 0.5 }} />
        <p className="text-muted mt-2">No Data</p>
      </div>
    </Container>
  );
};

export default PledgeRecord;
